/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// prototype pollution対策
import "no-pollution"

// CSS共通
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

// For Vue3
import autoCompleteComponent from './components/autoCompleteComponent.vue'
import snpSearchComponent from './components/snpSearchComponent.vue'
import graphImageComponent from './components/graphImageComponent.vue'
import genesEqtlTableComponent from './components/genesEqtlTableComponent.vue'
import snpsEqtlTableComponent from './components/snpsEqtlTableComponent.vue' 

// Use BootstrapTable plugin
import BootstrapTable from './plugins/table'

// For IE
import '@babel/polyfill'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import { createApp } from 'vue';
const app = createApp({})

// app.component('auto-complete-component', require('./components/autoCompleteComponent.vue').default);
// app.component('snp-search-component', require('./components/snpSearchComponent.vue').default);
// app.component('graph-image-component', require('./components/graphImageComponent.vue').default);
// app.component('genes-eqtl-table-component', require('./components/genesEqtlTableComponent.vue').default);
// app.component('snps-eqtl-table-component', require('./components/snpsEqtlTableComponent.vue').default);

app.component('auto-complete-component', autoCompleteComponent)
app.component('snp-search-component', snpSearchComponent)
app.component('graph-image-component', graphImageComponent)
app.component('genes-eqtl-table-component', genesEqtlTableComponent)
app.component('snps-eqtl-table-component', snpsEqtlTableComponent)

app.component('BootstrapTable', BootstrapTable)

app.mount('#app')

